export default "__VITE_ASSET__32d58482__"